import { render, staticRenderFns } from "./GeneralInfo.vue?vue&type=template&id=2b5bf9ae&scoped=true"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"
import style1 from "./GeneralInfo.vue?vue&type=style&index=1&id=2b5bf9ae&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5bf9ae",
  null
  
)

export default component.exports